import { render, staticRenderFns } from "./builds-deployments.vue?vue&type=template&id=bc685aa8"
import script from "./builds-deployments.vue?vue&type=script&lang=js"
export * from "./builds-deployments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports